// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"193":"6f79885f36babbf7","750":"744d4a2b58a96af7"}[chunkId] + ".js";
};